<template>
  <div>
    <!-- BLOG NEWS SETTINGS -->
    <sweet-modal ref="blogNewsSliderModal" width="800px">
      <div>
        <div class="row">
          <div class="col-md-12">
            <h5 v-text="$t('ct-display-options')" />
          </div>

          <!-- Featured news -->
          <div class="form-group col-md-5">
            <label for="selectTotalNews">{{ $t('ct-blog-news-source-modal')}}</label>
            <select class="form-control" v-model="options.featuredNews">
              <option :value="false">
                {{ $t('ct-blog-news-latest-modal') }}
              </option>
              <option :value="true">
                {{ $t('ct-blog-news-featured-modal') }}
              </option>
            </select>
          </div>

          <!-- Total news -->
          <div class="form-group col-md-3">
            <label for="selectTotalNews">{{ $t('ct-blog-news-total-modal') }}</label>
            <select class="form-control" v-model="options.totalNews">
              <option
              v-for="totalNews in [2,3,4,5,6,7,8]"
              :key="totalNews"
              :value="totalNews">
                {{ totalNews }}
              </option>
            </select>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <h5 v-text="$t('ct-settings')" />
          </div>

          <!-- Show title -->
          <div class="col-md-4">
            <div class="form-group">
              <input
                type="checkbox"
                id="show-title"
                v-model="options.showTitle"
                :value="true" />
              <label for="show-title" v-text="$t('ct-blog-news-show-title-modal')" />
            </div>
          </div>

          <!-- Show description -->
          <div class="col-md-4">
            <div class="form-group">
              <input
                type="checkbox"
                id="show-description"
                v-model="options.showDescription"
                :value="true" />
              <label for="show-description" v-text="$t('ct-blog-news-show-desc-modal')" />
            </div>
          </div>

          <!-- Redirect post -->
          <div class="col-md-4">
            <div class="form-group">
              <input
                type="checkbox"
                id="redirect-post"
                v-model="options.redirectUrl"
                :value="true" />
              <label for="redirect-post" v-text="$t('ct-blog-news-redirect-modal')" />
            </div>
          </div>
        </div>
        <div class="text-right">
          <button
            class="btn btn-success float-right"
            v-text="$t('ct-save')"
            @click="save"
          />
        </div>
      </div>
    </sweet-modal>
    <!-- BLOG NEWS SETTINGS -->


    <!-- WARNING BLOG -->
    <sweet-modal ref="blogNewsWarning" :title="$t('ct-warning')" width="40%" hide-close-button blocking>
      <div class="form-group">
        {{ modalWarning.message }}
      </div>
      <button
      slot="button"
      class="btn btn-outline-light"
      @click="$refs.blogNewsWarning.close()">
        Cancel
      </button>
    </sweet-modal>
    <!-- WARNING BLOG -->
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  import { getFilteredNews } from '../../../../../js/services/editor/blog.js'


  export default {
    name: "BlogNewsSliderConfigModals",
    components: {
      SweetModal,
    },
    data() {
      return {
        options: {
          totalNews: 4,
          featuredNews: false,
          showTitle: true,
          showDescription: true,
          redirectUrl: true,

        },
        modalWarning: {
          message: ''
        },
        callback: false
      };
    },
    methods: {
      init(config, callback = false) {
        this.options = config;
        this.callback = callback;
      },
      open(modal) {
        if (this.$refs[modal]) { this.$refs[modal].open() }
      },
      save() {

        getFilteredNews({
          type: 'group',
          filters: {
            category : 'all',
            author : 'all',
            featured : this.options.featuredNews,
            mostAccessed : false,
            amount : this.options.totalNews
          }
        })
        .then(({ data }) => {
          const news = data.data

          if( !news.length ) {

            this.modalWarning.message = 'Você não possui nenhum post em seu blog'
            return this.$refs.blogNewsWarning.open()

          }

          const config = { news, optionNews: { ...this.options } }

          this.callback(config)
          this.$refs.blogNewsSliderModal.close()
        })
        .catch(err => console.error(err))
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/NewsSlider/ConfigModals.vue